// src/config/buttonPositions.js
/**
 * ===============================================================================
 * CONFIGURACIÓN CENTRALIZADA DE POSICIONES DE BOTONES Y CHAT WIDGET
 * ===============================================================================
 * Modifica directamente las posiciones y valores en este fichero.
 * Los cambios se reflejarán DE INMEDIATO en el navegador al guardar (Hot Reload / HMR).
 * 
 * Claves de dispositivos disponibles en getDevPos:
 * - default: Valor por defecto de fallback
 * - fhd: Monitores Full HD (1920x1080)
 * - mac: Pantallas MacBook / Retina (1440x900, 1680x1050)
 * - desktop: Monitores de sobremesa estándar
 * - ipad: iPad en vertical (o isLandscape para horizontal)
 * - ipadPro: iPad Pro en vertical u horizontal
 * - surfacePro7: Tablets Surface Pro
 * - mobile: Móviles estándar en vertical (o mobileLandscape en horizontal)
 * - se, i12, i14ProMax, pixel7, xr, s8: Modelos específicos de móvil
 * - zFold, zFoldLand, zenbookFold, zenbookFoldLand: Dispositivos plegables
 * ===============================================================================
 */

// Re-exportaciones de widget para compatibilidad (la configuración principal reside en widgetPositions.js)
export {
  RECEPTION_WIDGET_CONFIG,
  ROOMS_WIDGET_CONFIG,
  getWidgetConfig,
  RECEPTION_CHAT_CONFIG,
  SERVICE_PAGES_CHAT_CONFIG
} from './widgetPositions';

// ===============================================================================
// CONFIGURACIÓN DE ENLACES Y TEXTOS DE CALENDLY POR ESPECIALIDAD
// ===============================================================================
export const CALENDLY_CONFIGS = {
  1: {
    url: "https://crm.tdahadultoonline.com/reservar-cita",
    title: "📅 Pide tu cita ahora",
    subtitle: "Sin esperas · 100% online"
  },
  22: {
    url: "https://crm.tdahadultoonline.com/reservar-cita",
    title: "📅 Pide tu cita ahora",
    subtitle: "Sin esperas · 100% online"
  },
  24: {
    url: "https://crm.tdahadultoonline.com/reservar-cita",
    title: "📅 Pide tu cita ahora",
    subtitle: "Sin esperas · 100% online"
  },
  26: {
    url: "https://crm.tdahadultoonline.com/reservar-cita",
    title: "📅 Pide tu cita ahora",
    subtitle: "Sin esperas · 100% online"
  },
  32: {
    url: "https://crm.tdahadultoonline.com/reservar-cita",
    title: "📅 Pide tu cita ahora",
    subtitle: "Sin esperas · 100% online"
  },
  34: {
    url: "https://crm.tdahadultoonline.com/reservar-cita",
    title: "📅 Pide tu cita ahora",
    subtitle: "Sin esperas · 100% online"
  },
  36: {
    url: "https://crm.tdahadultoonline.com/reservar-cita",
    title: "📅 Pide tu cita ahora",
    subtitle: "Sin esperas · 100% online"
  }
};

export const getCalendlyPosition = (getDevPos) => {
  return getDevPos({
    default: { left: "15%", top: "20%", transform: "none" },
    fhd: { left: "15%", top: "20%", transform: "none" },
    desktop: { left: "15%", top: "20%", transform: "none" },
    mac: { left: "15%", top: "20%", transform: "none" },
    zenbookFold: { left: "25%", top: "20%", transform: "none" },
    zenbookFoldLand: { left: "25%", top: "20%", transform: "none" },
    ipad: { left: "15%", top: "20%", transform: "none" },
    ipadPro: { left: "15%", top: "20%", transform: "none" },
    surfacePro7: { left: "15%", top: "20%", transform: "none" },
    surfacePro7Land: { left: "15%", top: "20%", transform: "none" },
    surfaceDuo: { left: "15%", top: "20%", transform: "none" },
    surfaceDuoLand: { left: "15%", top: "20%", transform: "none" },
    mobile: { left: "12px", top: "76px", transform: "none" },
    se: { left: "12px", top: "76px", transform: "none" },
    i12: { left: "12px", top: "76px", transform: "none" },
    i14ProMax: { left: "12px", top: "76px", transform: "none" },
    xr: { left: "12px", top: "76px", transform: "none" },
    s8: { left: "12px", top: "76px", transform: "none" },
    pixel7: { left: "12px", top: "76px", transform: "none" },
    galaxyA51: { left: "12px", top: "76px", transform: "none" },
    zFold: { left: "12px", top: "76px", transform: "none" },
    mobileLandscape: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    seLand: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    i12Land: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    i14ProLand: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    xrLand: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    s8Land: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    pixel7Land: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    galaxyA51Land: { left: "12px", top: "auto", bottom: "12px", transform: "none" },
    zFoldLand: { left: "12px", top: "auto", bottom: "12px", transform: "none" }
  });
};

// -------------------------------------------------------------------------------
// 2. CONFIGURACIÓN DE BOTONES DE NAVEGACIÓN POR PÁGINA
// -------------------------------------------------------------------------------

/**
 * Generador de configuración de navegación interactiva para HomePage
 */
export const getNavigationConfig = ({ getDevPos, goToPage, isMobile, isTablet, isLandscape }) => {
  return {
    // =========================================================================
    // PÁGINA 1 - RECEPCIÓN (Acceso a pasillos Este y Oeste)
    // =========================================================================
    1: {
      este: {
        text: "Unidad Psicología",
        tooltipText: "Navega a la Unidad de Psicología Online",
        position: getDevPos({
          default: { right: "10%", top: "20%" },
          desktop: { right: "8%", top: "50%" },
          mobile: { right: "6%", top: "40%" },
          fhd: { right: "7%", top: "50%" },
          mac: { right: "5%", top: "50%" },
          ipad: isLandscape ? { right: "20%", top: "35%" } : { right: "7%", top: "35%" },
          ipadPro: { right: "10%", top: "40%" },
          se: { right: "5%", top: "35%" },
          seLand: { right: "8%", top: "40%" },
          i12: { right: "5%", top: "35%" },
          pixel7: { right: "8%", top: "40%" },
          pixel7Land: { right: "17%", top: "22%" },
          xr: { right: "5%", top: "35%" },
          xrLand: { right: "23%", top: "25%" },
          s8: { right: "5%", top: "35%" },
          s8Land: { right: "12%", top: "40%" },
          surfaceDuo: { right: "11%", top: "40%" },
          zFold: { right: "3%", top: "30%" },
          zFoldLand: { right: "20%", top: "35%" },
          zenbookFoldLand: { right: "8%", top: "40%" },
          zenbookFold: { right: "5%", top: "40%" },
          galaxyA51: { right: "5%", top: "30%" },
          galaxyA51Land: { right: "11%", top: "24%" },
          surfacePro7Land: { right: "20%", top: "35%" },
        }),
        onClick: () => goToPage(2),
        icon: "right",
        textColor: "text-white",
        fontSize: { default: "text-sm", ipad: "text-xs", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", ipadPro: "text-lg", surfacePro7: "text-lg", surfacePro7Land: "text-xs", zFoldLand: "text-xs", zenbookFold: "text-xl" }
      },
      oeste: {
        text: "Unidad TDAH",
        tooltipText: "Navega a la Unidad especializada en TDAH",
        position: getDevPos({
          default: { left: "11%", top: "20%" },
          desktop: { left: "9%", top: "50%" },
          mobile: { left: "6%", top: "40%" },
          fhd: { left: "8%", top: "50%" },
          mac: { left: "5%", top: "50%" },
          ipad: isLandscape ? { left: "20%", top: "35%" } : { left: "7%", top: "35%" },
          ipadPro: { left: "10%", top: "40%" },
          se: { left: "5%", top: "35%" },
          seLand: { left: "8%", top: "40%" },
          i12: { left: "5%", top: "35%" },
          pixel7: { left: "8%", top: "40%" },
          pixel7Land: { left: "18%", top: "22%" },
          xr: { left: "5%", top: "35%" },
          xrLand: { left: "23%", top: "25%" },
          s8: { left: "5%", top: "35%" },
          s8Land: { left: "12%", top: "40%" },
          surfaceDuo: { left: "11%", top: "40%" },
          zFold: { left: "3%", top: "30%" },
          zFoldLand: { left: "20%", top: "35%" },
          zenbookFold: { left: "5%", top: "40%" },
          zenbookFoldLand: { left: "8%", top: "40%" },
          galaxyA51: { left: "5%", top: "30%" },
          galaxyA51Land: { left: "11%", top: "24%" },
          surfacePro7Land: { left: "20%", top: "35%" },
        }),
        onClick: () => goToPage(3),
        icon: "left",
        textColor: "text-white",
        fontSize: { default: "text-sm", ipad: "text-xs", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", ipadPro: "text-lg", surfacePro7: "text-lg", surfacePro7Land: "text-xs", zFoldLand: "text-xs", zenbookFold: "text-xl" }
      }
    },

    // =========================================================================
    // PÁGINA 2 - PASILLO UNIDAD DE PSICOLOGÍA (Ala Este)
    // =========================================================================
    2: {
      back: {
        text: isMobile ? "Ir a recepción" : isTablet ? "Ir a recepción" : "Volver a recepción",
        tooltipText: "Volver a la sala de recepción principal",
        position: getDevPos({
          default: { left: "50%", top: "70%", transform: "translateX(-50%)" },
          desktop: { left: "50%", top: "75%", transform: "translateX(-50%)" },
          fhd: { left: "50%", top: "75%", transform: "translateX(-50%)" },
          mac: { left: "50%", top: "72%", transform: "translateX(-50%)" },
          se: { left: "50%", top: "62%", transform: "translateX(-50%)" },
          seLand: { left: "75%", top: "52%", transform: "translateX(-50%)" },
          xr: { left: "50%", top: "70%", transform: "translateX(-50%)" },
          xrLand: { left: "70%", top: "55%", transform: "translateX(-50%)" },
          i12: { left: "50%", top: "70%", transform: "translateX(-50%)" },
          i12Land: { left: "70%", top: "50%", transform: "translateX(-50%)" },
          i14ProMax: { left: "50%", top: "70%", transform: "translateX(-50%)" },
          i14ProLand: { left: "70%", top: "55%", transform: "translateX(-50%)" },
          pixel7: { left: "50%", top: "70%", transform: "translateX(-50%)" },
          pixel7Land: { left: "70%", top: "52%", transform: "translateX(-50%)" },
          s8: { left: "50%", top: "67%", transform: "translateX(-50%)" },
          s8Land: { left: "70%", top: "50%", transform: "translateX(-50%)" },
          ipad: isLandscape ? { left: "50%", top: "65%", transform: "translateX(-50%)" } : { left: "50%", top: "78%", transform: "translateX(-50%)" },
          ipadPro: { left: "50%", top: "75%", transform: "translateX(-50%)" },
          surfacePro7: { left: "50%", top: "75%", transform: "translateX(-50%)" },
          surfaceDuo: { left: "50%", top: "70%", transform: "translateX(-50%)" },
          zFold: { left: "50%", top: "72%", transform: "translateX(-50%)" },
          zFoldLand: { left: "70%", top: "48%", transform: "translateX(-50%)" },
          zenbookFold: { left: "50%", top: "80%", transform: "translateX(-50%)" },
          zenbookFoldLand: { left: "50%", top: "75%", transform: "translateX(-50%)" },
          galaxyA51: { left: "50%", top: "70%", transform: "translateX(-50%)" },
          galaxyA51Land: { left: "70%", top: "52%", transform: "translateX(-50%)" },
          mobileLandscape: isLandscape ? { left: "80%", top: "50%" } : { left: "50%", top: "70%", transform: "translateX(-50%)" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", zFoldLand: "text-xs", seLand: "text-xs", i12Land: "text-xs", i14ProLand: "text-xs", s8Land: "text-xs", ipadPro: "text-2xl", surfacePro7: "text-2xl", zenbookFold: "text-2xl", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(1),
        icon: "down"
      },
      online01: {
        text: isMobile ? "Ansiedad y Depresión" : "Terapia de Ansiedad y Depresión",
        tooltipText: "Ir a consulta de Terapia de Ansiedad y Depresión",
        position: getDevPos({
          default: { left: "21%", top: "25%" },
          desktop: { left: "30%", top: "35%" },
          fhd: { left: "21%", top: "25%" },
          se: { left: "8%", top: "28%" },
          seLand: { left: "20%", top: "25%" },
          xr: { left: "5%", top: "30%" },
          xrLand: { left: "20%", top: "20%" },
          i12: { left: "4%", top: "20%" },
          i12Land: { left: "20%", top: "20%" },
          i14ProMax: { left: "4%", top: "25%" },
          i14ProLand: { left: "20%", top: "20%" },
          pixel7: { left: "10%", top: "25%" },
          pixel7Land: { left: "20%", top: "18%" },
          s8: { left: "8%", top: "25%" },
          s8Land: { left: "20%", top: "25%" },
          ipad: isLandscape ? { left: "10%", top: "25%" } : { left: "23%", top: "25%" },
          ipadPro: isLandscape ? { left: "10%", top: "25%" } : { left: "25%", top: "25%" },
          surfacePro7: { left: "21%", top: "25%" },
          mac: isLandscape ? { left: "15%", top: "25%" } : { left: "25%", top: "10%" },
          surfaceDuo: { left: "21%", top: "25%" },
          zFold: { left: "4%", top: "25%" },
          zFoldLand: { left: "20%", top: "18%" },
          zenbookFold: { left: "20%", top: "25%" },
          zenbookFoldLand: { left: "15%", top: "25%" },
          galaxyA51: { left: "10%", top: "25%" },
          galaxyA51Land: { left: "20%", top: "18%" },
          mobileLandscape: isLandscape ? { left: "20%", top: "20%" } : { left: "20%", top: "18%" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", seLand: "text-xs", i12Land: "text-xs", i14ProLand: "text-xs", s8Land: "text-xs", ipadPro: "text-2xl", surfacePro7: "text-2xl", zFoldLand: "text-xs", zenbookFold: "text-2xl", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(21),
        icon: "left"
      },
      online02: {
        text: isMobile ? "Terapia de Pareja" : "Terapia de Pareja",
        tooltipText: "Ir a consulta de Terapia de Pareja",
        position: getDevPos({
          default: { left: "30%", top: "40%" },
          desktop: { left: "21%", top: "20%" },
          fhd: { left: "30%", top: "38%" },
          se: { left: "40%", top: "40%" },
          seLand: { left: "30%", top: "40%" },
          xr: { left: "40%", top: "40%" },
          xrLand: { left: "30%", top: "40%" },
          i12: { left: "40%", top: "35%" },
          i12Land: { left: "30%", top: "38%" },
          i14ProMax: { left: "40%", top: "40%" },
          i14ProLand: { left: "30%", top: "38%" },
          pixel7: { left: "45%", top: "38%" },
          pixel7Land: { left: "30%", top: "35%" },
          s8: { left: "40%", top: "38%" },
          s8Land: { left: "30%", top: "40%" },
          ipad: isLandscape ? { left: "22%", top: "38%" } : { left: "45%", top: "38%" },
          ipadPro: isLandscape ? { left: "23%", top: "38%" } : { left: "48%", top: "38%" },
          surfacePro7: { left: "46%", top: "38%" },
          mac: isLandscape ? { left: "26%", top: "38%" } : { left: "25%", top: "10%" },
          surfaceDuo: { left: "46%", top: "38%" },
          zFold: { left: "40%", top: "38%" },
          zFoldLand: { left: "30%", top: "36%" },
          zenbookFold: { left: "45%", top: "38%" },
          zenbookFoldLand: { left: "26%", top: "38%" },
          galaxyA51: { left: "45%", top: "38%" },
          galaxyA51Land: { left: "30%", top: "35%" },
          mobileLandscape: isLandscape ? { left: "30%", top: "38%" } : { left: "30%", top: "35%" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", seLand: "text-xs", i12Land: "text-xs", i14ProLand: "text-xs", s8Land: "text-xs", ipadPro: "text-2xl", surfacePro7: "text-2xl", zFoldLand: "text-xs", zenbookFold: "text-2xl", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(23),
        icon: "left"
      },
      online03: {
        text: isMobile ? "Crecimiento Personal" : "Crecimiento Personal",
        tooltipText: "Ir a consulta de Crecimiento Personal",
        position: getDevPos({
          default: { left: "32%", top: "53%" },
          desktop: { left: "35%", top: "45%" },
          fhd: { left: "34%", top: "48%" },
          se: { left: "57%", top: "53%" },
          seLand: { left: "32%", top: "58%" },
          xr: { left: "57%", top: "53%" },
          xrLand: { left: "32%", top: "63%" },
          i12: { left: "57%", top: "48%" },
          i12Land: { left: "32%", top: "59%" },
          i14ProMax: { left: "57%", top: "53%" },
          i14ProLand: { left: "32%", top: "59%" },
          pixel7: { left: "57%", top: "53%" },
          pixel7Land: { left: "32%", top: "55%" },
          s8: { left: "57%", top: "53%" },
          s8Land: { left: "32%", top: "58%" },
          ipad: isLandscape ? { left: "27%", top: "53%" } : { left: "53%", top: "53%" },
          ipadPro: isLandscape ? { left: "27%", top: "53%" } : { left: "57%", top: "53%" },
          surfacePro7: { left: "57%", top: "53%" },
          mac: isLandscape ? { left: "29%", top: "53%" } : { left: "25%", top: "10%" },
          surfaceDuo: { left: "57%", top: "53%" },
          zFold: { left: "59%", top: "48%" },
          zFoldLand: { left: "32%", top: "57%" },
          zenbookFold: { left: "55%", top: "53%" },
          zenbookFoldLand: { left: "29%", top: "53%" },
          galaxyA51: { left: "57%", top: "53%" },
          galaxyA51Land: { left: "32%", top: "55%" },
          mobileLandscape: isLandscape ? { left: "32%", top: "59%" } : { left: "27%", top: "53%" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", seLand: "text-xs", i12Land: "text-xs", i14ProLand: "text-xs", s8Land: "text-xs", ipadPro: "text-2xl", surfacePro7: "text-2xl", zFoldLand: "text-xs", zenbookFold: "text-2xl", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(25),
        icon: "left"
      }
    },

    // =========================================================================
    // PÁGINA 3 - PASILLO UNIDAD TDAH (Ala Oeste)
    // =========================================================================
    3: {
      back: {
        text: isMobile ? "Ir a recepción" : isTablet ? "Ir a recepción" : "Volver a recepción",
        tooltipText: "Volver a la sala de recepción principal",
        position: getDevPos({
          default: { right: "50%", top: "70%", transform: "translateX(-0%)" },
          fhd: { right: "50%", top: "70%", transform: "translateX(50%)" },
          mac: { right: "50%", top: "72%", transform: "translateX(50%)" },
          se: { right: "50%", top: "62%", transform: "translateX(50%)" },
          seLand: { right: "75%", top: "52%", transform: "translateX(50%)" },
          xr: { right: "50%", top: "70%", transform: "translateX(50%)" },
          xrLand: { right: "70%", top: "55%", transform: "translateX(50%)" },
          i12: { right: "50%", top: "70%", transform: "translateX(50%)" },
          i12Land: { right: "70%", top: "50%", transform: "translateX(50%)" },
          i14ProMax: { right: "50%", top: "70%", transform: "translateX(50%)" },
          i14ProLand: { right: "70%", top: "55%", transform: "translateX(50%)" },
          pixel7: { right: "50%", top: "70%", transform: "translateX(50%)" },
          pixel7Land: { right: "70%", top: "52%", transform: "translateX(50%)" },
          s8: { right: "50%", top: "67%", transform: "translateX(50%)" },
          s8Land: { right: "70%", top: "50%", transform: "translateX(50%)" },
          ipad: isLandscape ? { right: "50%", top: "65%", transform: "translateX(50%)" } : { right: "50%", top: "70%", transform: "translateX(50%)" },
          ipadPro: { right: "50%", top: "75%", transform: "translateX(50%)" },
          surfacePro7: { right: "50%", top: "75%", transform: "translateX(50%)" },
          surfaceDuo: { right: "50%", top: "70%", transform: "translateX(50%)" },
          zFold: { right: "50%", top: "72%", transform: "translateX(50%)" },
          zFoldLand: { right: "70%", top: "48%", transform: "translateX(50%)" },
          zenbookFold: { right: "50%", top: "80%", transform: "translateX(50%)" },
          zenbookFoldLand: { right: "50%", top: "75%", transform: "translateX(50%)" },
          galaxyA51: { right: "50%", top: "70%", transform: "translateX(50%)" },
          galaxyA51Land: { right: "70%", top: "52%", transform: "translateX(50%)" },
          mobileLandscape: isLandscape ? { right: "80%", top: "50%" } : { right: "50%", top: "70%", transform: "translateX(50%)" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", zFoldLand: "text-xs", s8Land: "text-xs", ipad: "text-lg", ipadPro: "text-2xl", surfacePro7: "text-2xl", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(1),
        icon: "down"
      },
      tdah01: {
        text: isMobile ? "Test TDAH" : "Test/Evaluación TDAH",
        tooltipText: "Ir a consulta de Test/Evaluación TDAH",
        position: getDevPos({
          default: { right: "21%", top: "20%" },
          desktop: { right: "21%", top: "15%" },
          fhd: { right: "21%", top: "12%" },
          se: { right: "12%", top: "15%" },
          seLand: { right: "20%", top: "58%" },
          xr: { right: "5%", top: "15%" },
          xrLand: { right: "20%", top: "55%" },
          i12: { right: "6%", top: "15%" },
          i12Land: { right: "20%", top: "55%" },
          i14ProMax: { right: "6%", top: "15%" },
          i14ProLand: { right: "20%", top: "55%" },
          pixel7: { right: "6%", top: "15%" },
          pixel7Land: { right: "20%", top: "55%" },
          s8: { right: "12%", top: "15%" },
          s8Land: { right: "20%", top: "58%" },
          ipad: isLandscape ? { right: "16%", top: "15%" } : { right: "24%", top: "10%" },
          ipadPro: isLandscape ? { right: "12%", top: "12%" } : { right: "25%", top: "10%" },
          surfacePro7: { right: "21%", top: "12%" },
          mac: isLandscape ? { right: "15%", top: "12%" } : { right: "25%", top: "10%" },
          surfaceDuo: { right: "21%", top: "15%" },
          zFold: { right: "4%", top: "15%" },
          zFoldLand: { right: "20%", top: "55%" },
          zenbookFold: { right: "26%", top: "15%" },
          zenbookFoldLand: { right: "16%", top: "12%" },
          galaxyA51: { right: "12%", top: "15%" },
          galaxyA51Land: { right: "20%", top: "58%" },
          mobileLandscape: isLandscape ? { right: "15%", top: "60%" } : { right: "50%", top: "70%", transform: "translateX(50%)" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", se: "text-xs", ipad: "text-lg", ipadPro: "text-2xl", surfacePro7: "text-2xl", zFoldLand: "text-xs", galaxyA51Land: "text-xs", s8: "text-xs", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(31),
        icon: "right"
      },
      tdah02: {
        text: "TDAH Adultos",
        tooltipText: "Ir a consulta de TDAH Adultos",
        position: getDevPos({
          default: { right: "33%", top: "40%" },
          desktop: { right: "35%", top: "22%" },
          fhd: { right: "35%", top: "25%" },
          se: { right: "58%", top: "25%" },
          seLand: { right: "38%", top: "45%" },
          xr: { right: "63%", top: "25%" },
          xrLand: { right: "37%", top: "38%" },
          i12: { right: "61%", top: "25%" },
          i12Land: { right: "37%", top: "40%" },
          i14ProMax: { right: "23%", top: "25%", transform: "translateX(-100%)" },
          i14ProLand: { right: "37%", top: "40%" },
          pixel7: { right: "23%", top: "25%", transform: "translateX(-100%)" },
          pixel7Land: { right: "37%", top: "40%" },
          s8: { right: "63%", top: "25%" },
          s8Land: { right: "38%", top: "45%" },
          ipad: isLandscape ? { right: "35%", top: "25%" } : { right: "61%", top: "25%" },
          ipadPro: isLandscape ? { right: "33%", top: "25%" } : { right: "58%", top: "25%" },
          surfacePro7: { right: "61%", top: "25%" },
          mac: isLandscape ? { right: "35%", top: "25%" } : { right: "25%", top: "10%" },
          surfaceDuo: { right: "58%", top: "25%" },
          zFold: { right: "63%", top: "25%" },
          zFoldLand: { right: "37%", top: "40%" },
          zenbookFold: { right: "60%", top: "30%" },
          zenbookFoldLand: { right: "35%", top: "25%" },
          galaxyA51: { right: "58%", top: "25%" },
          galaxyA51Land: { right: "38%", top: "42%" },
          mobileLandscape: isLandscape ? { right: "38%", top: "43%" } : { right: "50%", top: "70%", transform: "translateX(50%)" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", se: "text-xs", i14ProMax: "text-xs", ipad: "text-lg", ipadPro: "text-2xl", surfacePro7: "text-2xl", zFoldLand: "text-xs", galaxyA51Land: "text-xs", s8: "text-xs", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(33),
        icon: "right"
      },
      tdah03: {
        text: "Asesoramiento Familias TDAH",
        tooltipText: "Ir a consulta de Asesoramiento Familias",
        position: getDevPos({
          default: { right: "35%", top: "50%" },
          desktop: { right: "39%", top: "32%" },
          fhd: { right: "39%", top: "35%" },
          se: { right: "65%", top: "40%" },
          seLand: { right: "39%", top: "28%" },
          xr: { right: "70%", top: "35%" },
          xrLand: { right: "39%", top: "22%" },
          i12: { right: "70%", top: "35%" },
          i12Land: { right: "39%", top: "22%" },
          i14ProMax: { right: "70%", top: "35%" },
          i14ProLand: { right: "39%", top: "22%" },
          pixel7: { right: "70%", top: "35%" },
          pixel7Land: { right: "39%", top: "22%" },
          s8: { right: "65%", top: "40%" },
          s8Land: { right: "39%", top: "28%" },
          ipad: isLandscape ? { right: "37%", top: "35%" } : { right: "68%", top: "40%" },
          ipadPro: isLandscape ? { right: "35%", top: "40%" } : { right: "67%", top: "35%" },
          surfacePro7: { right: "60%", top: "50%" },
          mac: isLandscape ? { right: "37%", top: "35%" } : { right: "25%", top: "10%" },
          surfaceDuo: { right: "67%", top: "35%" },
          zFold: { right: "65%", top: "35%" },
          zFoldLand: { right: "39%", top: "22%" },
          zenbookFold: { right: "66%", top: "40%" },
          zenbookFoldLand: { right: "37%", top: "35%" },
          galaxyA51: { right: "70%", top: "35%" },
          galaxyA51Land: { right: "39%", top: "26%" },
          mobileLandscape: isLandscape ? { right: "40%", top: "25%" } : { right: "50%", top: "70%", transform: "translateX(50%)" },
        }),
        fontSize: { default: "text-sm", mac: "text-base", fhd: "text-lg", mobile: "text-xs", xrLand: "text-xs", se: "text-xs", xr: "text-xs", i12: "text-xs", i14ProMax: "text-xs", pixel7: "text-xs", ipad: "text-lg", ipadPro: "text-2xl", surfacePro7: "text-2xl", zFold: "text-xs", zFoldLand: "text-xs", galaxyA51: "text-xs", galaxyA51Land: "text-xs", s8: "text-xs", mobileLandscape: isLandscape ? "text-xs" : "text-xs" },
        onClick: () => goToPage(35),
        icon: "right"
      },
    },

    // =========================================================================
    // SALAS DE CONSULTA - BOTÓN DE RETORNO A PASILLO (top: 25%, right: 1rem)
    // =========================================================================
    // Salas Unidad Psicología (Retorno a Página 2)
    22: { text: "Pasillo", tooltipText: "Volver al pasillo Ala Este", position: { right: "1rem", top: "25%" }, onClick: () => goToPage(2), icon: "right" },
    24: { text: "Pasillo", tooltipText: "Volver al pasillo Ala Este", position: { right: "1rem", top: "25%" }, onClick: () => goToPage(2), icon: "right", textColor: "text-white" },
    26: { text: "Pasillo", tooltipText: "Volver al pasillo Ala Este", position: { right: "1rem", top: "25%" }, onClick: () => goToPage(2), icon: "right" },
    // Salas Unidad TDAH (Retorno a Página 3)
    32: { text: "Pasillo", tooltipText: "Volver al pasillo Ala Oeste", position: { right: "1rem", top: "25%" }, onClick: () => goToPage(3), icon: "right" },
    34: { text: "Pasillo", tooltipText: "Volver al pasillo Ala Oeste", position: { right: "1rem", top: "25%" }, onClick: () => goToPage(3), icon: "right" },
    36: { text: "Pasillo", tooltipText: "Volver al pasillo Ala Oeste", position: { right: "1rem", top: "25%" }, onClick: () => goToPage(3), icon: "right", textColor: "text-white" },
  };
};
